import {getWizardItems} from "@/helpers/smart-wizard-helper";

export function initDependentFields() {
    const wizardItems = getWizardItems()
    wizardItems.map( wizardItem => {
        if(wizardItem.ShowFieldDependentAttributeID) {
            document.querySelector('form-element[data-id="' + wizardItem.AttributeID + '"]').classList.add('d-none')
        }
    })
}
export function checkDependentFields(element, value) {
    const wizardItems = getWizardItems()
    wizardItems.map( wizardItem => {
        if(wizardItem.ShowFieldDependentAttributeID) {
            const dependentAttribute = wizardItems.find( item => item.AttributeID === wizardItem.ShowFieldDependentAttributeID)
            if(dependentAttribute && parseInt(element.closest('form-element').dataset.id) === dependentAttribute.AttributeID) {
                const formElement = document.querySelector('form-element[data-id="' + wizardItem.AttributeID + '"]')
                if(String(value) === String(wizardItem.ShowFieldDependentValue)) {
                    formElement.classList.remove('d-none')
                } else {
                    formElement.classList.add('d-none')
                }
            }
        }
    })
}
